import Image from 'next/image'
import Link from 'next/link'

const CategoryWidgetNav = ({ category, parentClasses }) => {

    // Determine which items to show in the widget nav
    // Special handling for categories 10 (designers) and 11 (manufacturers):
    // - Direct children (e.g., Alessi under Manufacturers): show children (subcategories)
    // - Grandchildren+ (e.g., Alessi Kitchen): show siblings (other subcategories)
    const categoryTree = category.nav?.tree || category.tree || []
    const isUnderDesignerOrManufacturer = categoryTree.length > 1 && (categoryTree[0] == 10 || categoryTree[0] == 11)
    const isDirectChild = categoryTree.length === 2 // e.g., [11, alessi_id]
    // Use children only for direct children of 10/11 (brand/designer pages)
    // Otherwise use siblings
    const navItems = (isUnderDesignerOrManufacturer && isDirectChild)
        ? (category.children || [])
        : (category.siblings || [])

    if (navItems.length <= 1) {
        return null
    }

    return (
        <ul className={`grid grid-cols-2 gap-x-2 gap-y-5 md:grid-cols-3 xl:grid-cols-4 lg:gap-x-3 xl:gap-x-4 place-content-start auto-rows-min ${parentClasses}`}>
            {navItems.map((navCategory, index) => (
                <li key={navCategory.category_id || index}>
                    <Link href={navCategory.url} scroll={false} className={`overlay-block z-0 relative pl-0.5 pr-1 h-[50px] group flex items-center shadow-sm overflow-visible after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[2px] after:z-20 ${(category.category_id == navCategory.category_id) ? 'after:bg-primary text-primary font-medium' : 'after:bg-transparent'}`}>
                        {navCategory.layout_type == 7 ? (
                            <>
                                {navCategory.active_sale && (
                                    <div className="absolute top-0 right-0 z-20 pl-1.5 pr-2 pt-2 pb-0.5 font-medium text-2xs text-red">
                                        Sale
                                    </div>
                                )}
                                {navCategory.images?.brand_logo_left?.file_name && (
                                    <Image
                                        className="ml-3 mr-2 max-w-[150px]"
                                        src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${navCategory.images.brand_logo_left.file_name}`}
                                        alt={navCategory.images.brand_logo_left.alt || navCategory.category_name || 'Brand logo'}
                                        placeholder="blur"
                                        blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPcIgkAAYcAz3yXgHoAAAAASUVORK5CYII="
                                        width={navCategory.images.brand_logo_left.width}
                                        height={navCategory.images.brand_logo_left.height}
                                    />
                                )}
                            </>
                        ) : (
                            <>
                                {navCategory.images?.landing?.file_name &&
                                    <Image
                                        className="w-[45px] aspect-square object-contain ml-2 pr-1"
                                        src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${navCategory.images.landing.file_name}`}
                                        alt=""
                                        placeholder="blur"
                                        blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPcIgkAAYcAz3yXgHoAAAAASUVORK5CYII="
                                        width={navCategory.images.landing.width}
                                        height={navCategory.images.landing.height}
                                        sizes="45px"
                                    />
                                }
                                <div className="text-dark text-sm capitalize pl-2 group-hover:text-primary">{navCategory.category_name}</div>
                            </>
                        )}
                    </Link>
                </li>
            ))}
        </ul>
    )
}

export default CategoryWidgetNav
